'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Front';
import Breadcrumb from 'Components/Front/Breadcrumb';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import { URL, action } from 'Shared/Routes';
import { isTrue } from 'Shared/utilities';
const breadcrumb = [{
  name: 'home',
  url: URL('HomePage'),
  label: 'Accueil'
}, {
  name: 'current-page',
  label: 'Ma carte myWO',
  url: URL('WalletCard')
}];
const {
  app
} = window;
export default function WallerCardPage(props) {
  useEffect(() => {
    getCardStatus();
  }, []);
  const [has_card, setHasCard] = useState(app.state.session.user.wallet_enabled);
  const [redirect_loading, setRedirectLoading] = useState(false);
  const [status, setStatus] = useState({});
  const redirect_loader = redirect_loading === true ? /*#__PURE__*/React.createElement(Loader, {
    className: "c-loader",
    bemit: ['white', 'bg-blue']
  }) : undefined;
  const output = /*#__PURE__*/React.createElement(Layout, _extends({}, props, {
    meta_title: "Mon compte",
    meta_follow: false
  }), /*#__PURE__*/React.createElement("div", {
    className: bemit('c-front-page-intro', ['static-page'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__bg"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__left"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "c-front-page-intro__title"
  }, "Ma carte myWO")))), /*#__PURE__*/React.createElement("div", {
    className: "front-internal-page u-text-center"
  }, /*#__PURE__*/React.createElement(Breadcrumb, {
    links: breadcrumb,
    bemit: ['no-padding'],
    className: "u-margin-bottom-10"
  }), isTrue(has_card) ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['green', 'centered'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, "Vous avez d\xE9j\xE0 t\xE9l\xE9charg\xE9 votre carte myWO. Retrouvez-la dans l\u2019application Wallet de votre smartphone.")), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-margin-top-20"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/images/front/carte_myWO_exemple.jpg",
    alt: "Visuel exemple de carte myWO",
    title: "Exemple de carte myWO",
    className: "mywo-card-exemple-image"
  }))) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("p", null, "Toutes les actualit\xE9s myWO sur votre mobile gr\xE2ce \xE0 notre carte d\xE9mat\xE9rialis\xE9e\xA0:"), /*#__PURE__*/React.createElement("div", {
    className: "u-full-width u-margin-bottom-20"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "/images/front/carte_myWO_exemple.jpg",
    alt: "Visuel exemple de carte myWO",
    title: "Exemple de carte myWO",
    className: "mywo-card-exemple-image"
  })), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    className: bemit('c-flat-btn', ['front', 'blue', 'front-search']),
    onClick: requestRedirection
  }, "Je t\xE9l\xE9charge ma carte myWO", redirect_loader), getFormStatus(status))));
  return output;
  async function requestRedirection() {
    if (redirect_loading === true) return;
    setRedirectLoading(true);
    try {
      var response = await ajaxRequest(action('GetCaptainWalletUrl'), {
        data: {
          slug: 'myWO'
        }
      });
    } catch (e) {
      console.error(e);
      setRedirectLoading(false);
      return setStatus(e);
    }
    setRedirectLoading(false);
    return window.open(response.url);
  }
  async function getCardStatus() {
    try {
      var session = await ajaxRequest('/get-session');
    } catch (e) {
      console.error(e);
      return setStatus(e);
    }
    return setHasCard(isTrue(session.user.wallet_enabled));
  }
}
